import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";
import { AavoSelectField, AavoSelectFieldProps } from "../../../../common/inputFields/AavoSelectField.tsx";
import { Site } from "src/api/generated/erp/db/types/tables/site.ts";
import i18n from "i18next";
import { mergeSx } from "src/utils/styles.ts";

export interface SelectSiteFieldProps<DisableClearable extends boolean | undefined>
	extends Omit<
		AavoSelectFieldProps<Site, number, DisableClearable>,
		"options" | "getOptionKey" | "getOptionLabel" | "label"
	> {
	label?: string;
}

export const SelectSiteField = <DisableClearable extends boolean | undefined>({
	sx,
	...other
}: SelectSiteFieldProps<DisableClearable>) => {
	const { userSites, defaultSiteId } = useGlobalInitData();

	if (userSites.length < 2) {
		return null;
	}

	return (
		<AavoSelectField<Site, number, DisableClearable>
			label={i18n.t("site")}
			options={userSites}
			getOptionKey={(site) => site.siteId}
			getOptionLabel={(site) => site.siteName}
			defaultValue={defaultSiteId}
			sx={mergeSx(
				{
					minWidth: 100,
				},
				sx,
			)}
			{...other}
		/>
	);
};
